<template>
    <!--<SoliForm
        v-if="dialog"
        :title="location.name"
        @reset="[(dialog = false), $emit('reset')]"
        imgSrc="/grandview-exterior.webp"
        hideBtn
    >
        <template #body>
            <v-container v-if="location.cm" class="flex">
                <v-list-item-avatar size="64" class="shadow-blue">
                    <v-img :src="location.cm?.profile_photo_url"></v-img>
                </v-list-item-avatar>
                <div class="align-self-center pa-3">
                    <small>Community Manager</small>
                    <div>{{ location.cm.name }}</div>
                </div>
            </v-container>

            <v-card-actions class="justify-space-around mb-3"
                ><v-btn icon :href="'tel:' + location.phone"
                    ><v-icon color="dark">phone</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Call</small
                    > </v-btn
                ><v-btn icon :href="'sms:' + location.phone"
                    ><v-icon color="dark">sms</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Text</small
                    > </v-btn
                ><v-btn icon :href="'mailto:' + location.email"
                    ><v-icon color="dark">email</v-icon>
                    <small class="mt-1 panel-text" style="text-transform: none"
                        >Email</small
                    >
                </v-btn></v-card-actions
            >
        </template>
    </SoliForm>-->
    <SoliLocationExpandedContent
        :location="location"
        :value="location"
        class="mt-3"
        :icon="null"
    />
</template>

<script>
export default {
    props: {
        location: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            dialog: true,
        };
    },
};
</script>
